import { useCallback, useEffect, useState } from 'react';
import { fetchActiveCreditPacks, type CreditPackView } from './creditPacks.api';

export interface UseCreditPacksResult {
  packs: CreditPackView[];
  loading: boolean;
  error: string | null;
  reload: () => Promise<void>;
}

export function useCreditPacks(): UseCreditPacksResult {
  const [packs, setPacks] = useState<CreditPackView[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await fetchActiveCreditPacks();
      setPacks(data.sort((a, b) => a.displayOrder - b.displayOrder || a.credits - b.credits));
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to load credit packs');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void load();
  }, [load]);

  return { packs, loading, error, reload: load };
}
